// extracted by mini-css-extract-plugin
module.exports =  {"root":"AjWAdH7wdcWvnCygue7j"};